/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubscriberControlRegretDetail {
  amount?: number;
  badge?: string;
  boxId?: string;
  cancellationReason?: string;
  chargeAmount?: number;
  compositionId?: number;
  compositionName?: string;
  couponId?: number;
  couponName?: string;
  cpf?: number;
  dateRenewed?: Date;
  editionId?: number;
  email?: string;
  fee?: number;
  name?: string;
  personType?: string;
  phone?: string;
  refundAmount?: number;
  statusMillennium?: string;
  subscriberCancellationReasonName?: string;
  subscriberEditionName?: string;
  subscriberEditionStatusName?: string;
  subscriberGroupId?: number;
  subscriberId?: number;
  subscriberStatus?: string;
  subscriptionName?: string;
  subscriptionTypeName?: string;
  theme?: string;
}
